module.exports = __webpack_public_path__ + "media/party.bc51df5f.mp4";